import axios from 'axios'
import { cleanBlankValue, openNewTabBlobFile } from 'utils/helper'

export const getFinancePurchaseInvoices = (params) => {
  return axios.get('/finance/purchaseInvoices', { params })
}

export const getTotalFinancePurchaseInvoices = (params) => {
  return axios.get('/finance/purchaseInvoices/totals', { params })
}

export const addFinancePurchaseInvoice = (data) => {
  return axios.post('/finance/purchaseInvoices', data)
}

export const editFinancePurchaseInvoice = (data) => {
  return axios.put(`/finance/purchaseInvoices/${data.id}`, data)
}

export const deleteOnAddFinancePurchaseInvoiceAttachment = (url) => {
  return axios.delete('/finance/purchaseInvoices/attachments', { data: { url } })
}

export const deleteOnEditFinancePurchaseInvoiceAttachment = (id, url) => {
  return axios.delete(`/finance/purchaseInvoices/${id}/attachments`, { data: { url } })
}

export const getFinancePurchaseInvoice = (id, params) => {
  return axios.get(`/finance/purchaseInvoices/${id}`, { params })
}

export const getFinancePurchaseInvoiceLog = ({ id, params } = {}) => {
  return axios.get(`/finance/purchaseInvoices/${id}/logs`, { params })
}

export const changeFinancePurchaseInvoiceStatus = (id, data) => {
  return axios.patch(`/finance/purchaseInvoices/${id}/status`, data)
}

export const deleteFinancePurchaseInvoice = (id) => {
  return axios.delete(`/finance/purchaseInvoices/${id}`)
}

export const getFinancePurchaseInvoiceOverview = (params) => {
  return axios.get(`/finance/purchaseInvoices/overview`, { params })
}

export const uploadImportFinancePurchaseInvoice = (data) => {
  return axios.postForm('/finance/purchaseInvoices/uploadImport', data)
}

export const executeImportFinancePurchaseInvoice = (data) => {
  return axios.post('/finance/purchaseInvoices/executeImport', data)
}

export const uploadImportStatusFinancePurchaseInvoice = (data) => {
  return axios.postForm('/finance/purchaseInvoices/payment/uploadImport', data)
}

export const executeImportStatusFinancePurchaseInvoice = (data) => {
  return axios.post('/finance/purchaseInvoices/payment/executeImport', data)
}

export const createPdfFinancePurchaseInvoice = (id) => {
  return axios
    .get(`/finance/purchaseInvoices/${id}/print`, { responseType: 'blob' })
    .then((response) => {
      openNewTabBlobFile(response)

      return Promise.resolve(true)
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

export const getFinancePurchaseInvoicePublicUrl = (id) => {
  return axios.get(`/finance/purchaseInvoices/${id}/publicUrl`)
}

export const exportFinancePurchaseInvoice = (params) => {
  const URL =
    params.status_id === 'recurring'
      ? 'purchaseInvoices/recurring/export'
      : 'purchaseInvoices/export'
  if (params.status_id === 'recurring') {
    delete params.status_id
  }
  const query = cleanBlankValue(params)
  return axios.get(`/finance/${URL}`, { responseType: 'arraybuffer', params: query })
}

export const getFinancePurchaseInvoiceWaTemplate = (id) => {
  return axios.get(`/finance/purchaseInvoices/${id}/whatsapp`)
}

export const getFinancePurchaseInvoiceInputWhatsappTemplate = (id) => {
  return axios.get(`/finance/purchaseInvoices/${id}/inputWhatsapp`)
}

export const sendFinancePurchaseInvoiceWhatsapp = (payload) => {
  const { id, ...body } = payload
  return axios.post(`/finance/purchaseInvoices/${id}/whatsapp`, body)
}

export const getFinancePurchaseInvoiceEmailTemplate = (id) => {
  return axios.get(`/finance/purchaseInvoices/${id}/email`)
}

export const sendFinancePurchaseInvoiceEmail = (id, data) => {
  return axios.post(`/finance/purchaseInvoices/${id}/email`, data)
}

export const addRecurringPurchaseInvoice = (data) => {
  return axios.post('/finance/purchaseInvoices/recurring', data)
}

export const editRecurringPurchaseInvoice = (data) => {
  return axios.put(`/finance/purchaseInvoices/recurring/${data.id}`, data)
}

export const getRecurringPurchaseInvoice = (id) => {
  return axios.get(`/finance/purchaseInvoices/recurring/${id}`)
}

export const deleteRecurringPurchaseInvoice = (id) => {
  return axios.delete(`/finance/purchaseInvoices/recurring/${id}`)
}

export const getRecurringPurchaseInvoices = (params) => {
  return axios.get('/finance/purchaseInvoices/recurring', { params })
}

export const getFinancePurchaseInvoiceSmsTemplate = (id) => {
  return axios.get(`/finance/purchaseInvoices/${id}/sms`)
}

export const sendFinancePurchaseInvoiceSms = (id, data) => {
  return axios.post(`/finance/purchaseInvoices/${id}/sms`, data)
}

export const inputMassDeleteFinancePurchaseInvoice = (data) => {
  return axios.post('/finance/purchaseInvoices/inputMassDelete', data)
}

export const executeMassDeleteFinancePurchaseInvoice = (data) => {
  return axios.delete('/finance/purchaseInvoices/executeMassDelete', { data })
}

export const inputMassSendEmailFinancePurchaseInvoice = (data) => {
  return axios.post('/finance/purchaseInvoices/inputMassEmail', data)
}

export const executeMassSendEmailFinancePurchaseInvoice = (data) => {
  return axios.post('/finance/purchaseInvoices/executeMassEmail', data)
}

export const inputMassSendWhatsappFinancePurchaseInvoice = (data) => {
  return axios.post('/finance/purchaseInvoices/inputMassWhatsapp', data)
}

export const executeMassSendWhatsappFinancePurchaseInvoice = (data) => {
  return axios.post('/finance/purchaseInvoices/executeMassWhatsapp', data)
}

export const getMassDownloadFinancePurchaseInvoice = (params) => {
  return axios.get('/finance/purchaseInvoices/massDownload', { params })
}

export const getMinTransDateFinancePurchaseInvoice = (data) => {
  return axios.post('/finance/purchaseInvoices/mass/minDate', data)
}

export const inputMassPatchFinancePurchaseInvoice = (data) => {
  return axios.post('/finance/purchaseInvoices/inputMassPatch', data)
}

export const executeMassPatchFinancePurchaseInvoice = (data) => {
  return axios.patch('/finance/purchaseInvoices/executeMassPatch', data)
}

export const inputMassCreateFinancePurchaseInvoice = (data) => {
  return axios.post('/finance/purchaseInvoices/inputMassPurchaseInvoice', data)
}

export const executeMassCreateFinancePurchaseInvoice = (data) => {
  return axios.post('/finance/purchaseInvoices/executeMassPurchaseInvoice', data)
}

export const approveFinancePurchaseInvoice = ({ id }) => {
  return axios.post(`/finance/purchaseInvoices/${id}/approve`)
}

export const rejectFinancePurchaseInvoice = ({ id, body }) => {
  return axios.post(`/finance/purchaseInvoices/${id}/reject`, body)
}

export const revertApprovalFinancePurchaseInvoice = ({ id }) => {
  return axios.post(`/finance/purchaseInvoices/${id}/revert`)
}

export const uploadImportFinancePurchaseInvoiceRecurring = (data) => {
  return axios.postForm('/finance/purchaseInvoices/import/recurring/uploadImport', data)
}

export const executeImportFinancePurchaseInvoiceRecurring = (data) => {
  return axios.post('/finance/purchaseInvoices/import/recurring/executeImport', data)
}

export const uploadImportFinancePurchaseInvoiceReturn = (data) => {
  return axios.postForm('/finance/purchaseReturns/uploadImport', data)
}

export const executeImportFinancePurchaseInvoiceReturn = (data) => {
  return axios.post('/finance/purchaseReturns/executeImport', data)
}

export const editOnCompletePurchaseInvoice = (data) => {
  return axios.patch(`/finance/purchaseInvoices/${data.id}`, data)
}

/**
 * Draf baris Faktur Pembelian dari Permintaan Pembelian terpilih.
 * Param: requestIds (dipisah koma, maks 100). Respons: items[] (dengan
 * purchase_request_item_id + product ter-embed) + skipped[]. Angka dihitung BE.
 */
export const getDraftPurchaseInvoiceFromRequest = (params) => {
  return axios.get('/finance/purchaseInvoices/draftFromPurchaseRequest', { params })
}
